import fetch from '../config/fetch'


/**
 * 获取数据
 */


export const getAgentInfo = (brandId) => fetch('/agent/my/getAgentInfo', {
    brandId:brandId
}
);

export const getAgentBrandList = () => fetch('/agent/my/getAgentBrandList', {
}
);

export const getFrontAgentBrandList = () => fetch('/agent/my/getFrontAgentBrandList', {
}
);

export const updatePwd=(oldPwd,newPwdOne,newPwdTwo) => fetch('/agent/my/updatePwd', {
    oldPwd:oldPwd,
    newPwdOne:newPwdOne,
    newPwdTwo:newPwdTwo
}
);

export const logOut = () => fetch('/agent/my/logOut', {
}
);

export const submitAddress = (name,phone,myAddress,detail) => fetch('/agent/my/submitAddress', {
    name:name,
    phone:phone,
    myAddress:myAddress,
    detail:detail
}
);

export const updateAddress = (name,phone,myAddress,detail,addressId) => fetch('/agent/my/updateAddress', {
    name:name,
    phone:phone,
    myAddress:myAddress,
    detail:detail,
    addressId:addressId
}
);

export const updateDefault = (addressId) => fetch('/agent/my/updateDefault', {
 addressId:addressId
}
);

export const getAddressByAddressId = (addressId) => fetch('/agent/my/getAddressByAddressId', {
 addressId:addressId
}
);

export const deleteAddress = (addressId) => fetch('/agent/my/deleteAddress', {
 addressId:addressId
}
);

export const getAddressList = () => fetch('/agent/my/getAddressList', {
}
);

export const getBankList = (bankType) => fetch('/agent/my/getBankList', {
    bankType:bankType
}
);

export const addBank = (account,bankName,accountAsname,bankType,img_url) => fetch('/agent/my/addBank', {
    account:account,
    bankName:bankName,
    accountAsname:accountAsname,
    bankType:bankType,
    img_url:img_url
},"POST"
);

export const deleteBank = (bankId) => fetch('/agent/my/deleteBank', {
    bankId:bankId
}
);


export const getCompanyBankList = (bankType) => fetch('/agent/my/getCompanyBankList', {
    bankType:bankType
}
);

export const getTransferBankList = (bankType,brandId) => fetch('/agent/my/getTransferBankList', {
    bankType:bankType,
    brandId:brandId
}
);

export const addTransfer=(bankId,money,imageUrl,brandId) => fetch('/agent/my/addTransfer', {
    bankId:bankId,
    money:money,
    imageUrl:imageUrl,
    brandId:brandId
},'POST'
);

export const getTransferList=() => fetch('/agent/my/getTransferList', {
},
);

export const getMyOrdersList=(isInternal,brandId) => fetch('/agent/my/getMyOrdersList', { 
    isInternal:isInternal,
    brandId:brandId
}
);

export const getSubOrdersList=(isInternal,brandId) => fetch('/agent/my/getSubOrdersList', { 
    isInternal:isInternal,
    brandId:brandId
}
);

export const getTwoSubOrdersList=(isInternal,brandId) => fetch('/agentTeam/getTwoSubOrdersList', { 
    isInternal:isInternal,
    brandId:brandId
}
);

export const getTeamSubOrdersList=(isInternal,brandId) => fetch('/agentTeam/getTeamSubOrdersList', { 
    isInternal:isInternal,
    brandId:brandId
}
);

export const getOrderdetails=(orderId) => fetch('/agent/my/getOrderdetails', { 
    orderId:orderId
}
);
export const getShopOrderdetails=(orderId) => fetch('/agent/my/getShopOrderdetails', { 
    orderId:orderId
}
);

export const confirmGoods=(orderId) => fetch('/agent/my/confirmGoods', { 
    orderId:orderId
}
);

export const getAgentTypeList=(brandId,agentType) => fetch('/agent/my/getAgentTypeList', { 
    brandId:brandId,
    agentType:agentType
}
);

export const createQrcode=(brandId,agentType,shareUrl,level) => fetch('/agent/my/createQrcode', { 
    brandId:brandId,
    agentType:agentType,
    shareUrl:shareUrl,
    level:level
}
);

export const submitAvatar=(imageUrl)=> fetch('/agent/my/submitAvatar', { 
    imageUrl:imageUrl
},'POST'
);

export const agentQuery=(data)=> fetch('/agent/agentQuery', { 
    data:data
},
);
export const myReward=()=> fetch('/agent/my/myReward', { 
},
);

export const getAgentTeamInfo = (brandId) => fetch('/agentTeam/findByAgentId', {
    brandId:brandId

}
);

export const updateAgentTeamInfo = (teamName,teamIntroduce,imageUrl,brandId) => fetch('/agentTeam/update', {
    teamName:teamName,
    teamIntroduce:teamIntroduce,
    imageUrl:imageUrl,
    brandId:brandId,
},
);

export const findPersonsByAgentId = (brandId) => fetch('/agentTeam/findPersonsByAgentId', {
    brandId:brandId
},
);

export const findNewPersonsByAgentId = (brandId) => fetch('/agentTeam/findNewPersonsByAgentId', {
    brandId:brandId
},
);

export const findAllAgentType = (brandId,agentTypeId) => fetch('/agentTeam/findAllAgentType', {
    brandId:brandId,
    agentTypeId:agentTypeId
},
);

export const findAllAgentTypeAndNewAgent = (brandId) => fetch('/agentTeam/findAllAgentTypeAndNewAgent', {
    brandId:brandId
},
);

export const findOrders = (brandId) => fetch('/agentTeam/findOrders', {
    brandId:brandId
},
);

export const getUpgradeInfo = (brandId) => fetch('/agent/my/getUpgradeInfo', {
    brandId:brandId,
}
);
export const  submitUpgrade=(brandId,rechargeImages,takeImages,bondImages,bondPrice,isBond,agentTypeId) => fetch('/agent/my/submitUpgrade', {
    brandId:brandId,
    rechargeImages:rechargeImages,
    takeImages:takeImages,
    bondImages:bondImages,
    bondPrice:bondPrice,
    isBond:isBond,
    agentTypeId:agentTypeId
},'POST'
);

export const  rewardToDeposit=(reward) => fetch('/agent/my/rewardToDeposit', {
    reward:reward
},
);

export const  subTransferInfo=(pageNumber,state) => fetch('/agent/my/subTransferInfo', {
    pageNumber:pageNumber,
    state:state
},
);

export const  auditSubTransfer=(orderId) => fetch('/agent/my/auditSubTransfer', {
    orderId:orderId
},
);
//获取消息
export const getMessageList = (message_type,page_num,page_size,is_read,brandId) => fetch('/agent/my/getMessageList', {
    message_type:message_type,
    page_num:page_num,
    page_size:page_size,
    is_read:is_read,
    brandId:brandId
},
);

//获取消息详情
export const getMessageDetail = (id) => fetch('/agent/my/getMessageDetail', {
    messageid:id,
},
);


//获取系统设置值
export const getSettingVal = (settingkey) => fetch('/setting/getSettingVal', {
    settingkey:settingkey,
},
);

//获取系统设置值
export const uploadcashdesposit = (picurl,brandId) => fetch('/agent/my/uploadcashdesposit', {
    picurl:picurl,
    brandId:brandId
},'POST'
);

//获取升级记录
export const findUpdateRecord = (brandId) => fetch('/agentTeam/findUpdateRecord', {
    brandId:brandId,
}
);


export const getFirstAgentTypeName = () => fetch('/agent/my/getFirstAgentTypeName', {
}
);

export const getMyBankList = (bankType) => fetch('/agent/my/getMyBankList', {
    bankType:bankType
}
);

export const getAuthPicByBrandId = (brandId) => fetch('/agent/my/getAuthPicByBrandId', {
    brandId:brandId
}
);

export const getOnlyTeamAchievementInfo=(brandId,dateTime) => fetch('/agentTeam/getOnlyTeamAchievementInfo', { 
    brandId:brandId,
    dateTime:dateTime
}
);

export const getBondInfo=(brandId,agentTypeId) => fetch('/agent/my/getBondInfo', { 
    brandId:brandId,
    agentTypeId:agentTypeId
}
);

export const getSettingInfo=(brandId) => fetch('/setting/getSettingInfo', { 
    brandId:brandId,
}
);

export const auditSubOrders=(orderId,auditType,brandId,actionType) => fetch('/agent/order/auditSubOrders', { 
    orderId:orderId,
    auditType:auditType,
    brandId:brandId,
    actionType:actionType
},"POST"
);

export const auditSubFailOrders=(orderId,brandId,actionType) => fetch('/agent/order/auditSubFailOrders', { 
    orderId:orderId,
    brandId:brandId,
    actionType:actionType
},"POST"
);

export const getMonthAchievementInfo=(brandId) => fetch('/agent/getMonthAchievementInfo', { 
    brandId:brandId
}
);

export const getMoblieCode=(mobile) => fetch('/agent/getMoblieCode', { 
    mobile:mobile
}
);

export const createSignature=(url) => fetch('/agent/createSignature', { 
    url:url
},"POST"
);

export const getAgentType=() => fetch('/agent/getAgentType', { 
}
);

export const goSaveAgentBrand=(agentId,isWxInter,brandName,brandImageUrl,brandArea,brandImages,productName,productImg,productSpec,agentType) => fetch('/agent/goSaveAgentBrand', { 
    agentId:agentId,
    isWxInter:isWxInter,
    brandName:brandName,
    brandImageUrl:brandImageUrl,
    brandArea:brandArea,
    brandImages:brandImages,
    productName:productName,
    productImg:productImg,
    productSpec:productSpec,
    agentType:agentType
},"POST"
);

export const fingBrandByAgentId=(agentId) => fetch('/agent/fingBrandByAgentId', { 
    agentId:agentId,
}
);

export const fingByAgentId=(agentId) => fetch('/agent/fingByAgentId', { 
    agentId:agentId,
}
);

export const goCertification=(brandId,agentId,certificationType,name,idNo,weixin,gAddress,image1,image2,bankTypeId,bankAccount,companyName,scope,qAddress,rechargeImageList) => fetch('/agent/goCertification', { 
    brandId:brandId,
    agentId:agentId,
    certificationType:certificationType,
    name:name,
    idNo:idNo,
    weixin:weixin,
    gAddress:gAddress,
    image1:image1,
    image2:image2,
    bankTypeId:bankTypeId,
    bankAccount:bankAccount,
    companyName:companyName,
    scope:scope,
    qAddress:qAddress,
    rechargeImageList:rechargeImageList
},"POST"
);

export const getCertificationInfo = (brandId) => fetch('/agent/getCertificationInfo', {
    brandId:brandId
}
);

export const updateAgentOpenid = (openid) => fetch('/agent/my/updateAgentOpenid', {
    openid:openid
}
);

export const isTopLevel = (brandId,agentType) => fetch('/agent/my/isTopLevel', {
    brandId:brandId,
    agentType:agentType
}
);

export const subTransfer = (brandId) => fetch('/setting/subTransfer', {
    brandId:brandId
}
);

export const delOpenid = (inputCode) => fetch('/agent/my/delOpenid', {
    inputCode:inputCode
}
);

export const isOnlyWxLogin = () => fetch('/setting/isOnlyWxLogin', {
}
);

export const getMonthlySettlementList = (brandId,pageNumber,pageSize) => fetch('/agentMonthlySettlement/getMonthlySettlementList', {
    brandId:brandId,
    pageNumber:pageNumber,
    pageSize:pageSize
}
);



// WEBPACK FOOTER //
// ./src/service/my.js